import { Root } from './Root';
import { Body, Footer, Header } from './styled';
export const SidebarDialogLayout = {
    Root,
    Header,
    Footer,
    Body,
};
